// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        //
        $('#block-rooms-block .block_link span').click(function(){
            $("#block-rooms-block .field--name-body").addClass("show_all");
            $("#block-rooms-block .block_link").addClass("hide_link");
        });

        // слайдер на главной
        $('.slider_block_inner .view-slider .view-content').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 1000,
            slideSpeed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        });

        // add link
        $(".furniture_block .field--name-field-block-paragraph").append('<div class="field__link"><a href="#block-rooms-block">Забронировать онлайн</a></div>');

        // add now year
        var currentYear = new Date().getFullYear();
        $(".copyright_box .now_year").prepend(currentYear+" ");

    });
})(jQuery);